<template>
  <v-card class="pa-2" max-width="374">
    <v-sheet>
      <v-card-title>Finance Details</v-card-title>

      <v-card-text>
        <div class="my-4 text-h4 text-center  green--text">
          $ {{ financeSideData.Amount }}
        </div>

        <div class="text-center mt-n4">
          Available Balance
        </div>
      </v-card-text>
    </v-sheet>

    <v-divider class="mt-5"></v-divider>

    <v-card-text class="mt-3">
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-calendar-month
        </v-icon>
        <span class="subheading mr-2">Date Period</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{ datePeriod }}</span>
        </v-row>
      </v-list-item>
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-finance
        </v-icon>
        <span class="subheading mr-2">Status</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{
            closeOut ? "Close Out" : "Active"
          }}</span>
        </v-row>
      </v-list-item>
    </v-card-text>

    <v-divider class="mt-5"></v-divider>
    <v-card-text class="mt-3">
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-cash-check
        </v-icon>
        <span class="subheading mr-2">Cash</span>
        <v-row align="center" justify="end">
          <span class="subheading">${{ financeSideData.Cash }}</span>
        </v-row>
      </v-list-item>
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-cash-check
        </v-icon>
        <span class="subheading mr-2">EBT</span>
        <v-row align="center" justify="end">
          <span class="subheading">${{ financeSideData.EBT }}</span>
        </v-row>
      </v-list-item>
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-cash-check
        </v-icon>
        <span class="subheading mr-2">Debit Card</span>
        <v-row align="center" justify="end">
          <span class="subheading">${{ financeSideData.DebitCard }}</span>
        </v-row>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { setUserTz, tz } from "../../../utils/timezone";

export default {
  props: {
    financeItemData: {
      type: Array,
      default: () => [],
    },
    amount: {
      type: String,
    },
    date: {
      type: Array,
      default: () => [],
    },
    closeOut: {
      type: Boolean,
    },
    financeID: {
      type: String,
    },
  },

  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    financeSideData() {

      let initlaValue = parseFloat(0).toFixed(2)
      
      const filterFinances = this.financeItemData.find(
        (item) => item._id === this.financeID
      );
      let amount = parseFloat(filterFinances?.Balance?.$numberDecimal).toFixed(
        2
      );

      let Cash = parseFloat(filterFinances?.Cash?.$numberDecimal).toFixed(2);
      let EBT = parseFloat(filterFinances?.EBT?.$numberDecimal).toFixed(2);
      let DebitCard = parseFloat(
        filterFinances?.DebitCard?.$numberDecimal
      ).toFixed(2);

      return {
        Amount: isNaN(amount) ? initlaValue : amount,
        Cash: isNaN(Cash) ? initlaValue : Cash,
        EBT: isNaN(EBT) ? initlaValue : EBT,
        DebitCard: isNaN(DebitCard) ? initlaValue : DebitCard,
      };
    },

    datePeriod() {
      let transactionDates = this.$store.state.financeTransactions.item.map(
        (item) => item.Date
      );

      let earliestDate = this.getMinDate(transactionDates);
      let latestDate = this.getMaxDate(transactionDates);
      let datePeriod = "";

      if ((earliestDate && latestDate) == "Invalid Date") {
        return null;
      }

      if (Date.parse(earliestDate) == Date.parse(latestDate)) {
        return (datePeriod = `${tz(earliestDate, this.userTimezone).format(
          "DD MMM"
        )} - Present`);
      }

      datePeriod = `${tz(earliestDate, this.userTimezone).format(
        "DD MMM"
      )} - ${tz(latestDate, this.userTimezone).format("DD MMM")}`;

      return datePeriod;
    },
  },

  methods: {
    getMaxDate(dates) {
      let moments = dates.map((x) => moment(x)),
        maxDate = moment.max(moments).format("YYYY-MM-DD");
      return maxDate;
    },
    getMinDate(dates) {
      let moments = dates.map((x) => moment(x)),
        maxDate = moment.min(moments).format("YYYY-MM-DD");
      return maxDate;
    },
  },
};
</script>
